import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Button } from "@kmf/ui";

export function NotFoundPage() {
  useEffect(() => {
    document.title = "페이지를 찾을 수 없습니다 - KMF 할랄위원회";
  }, []);

  return (
    <div className="flex min-h-[60vh] items-center py-12 md:py-16">
      <Container>
        <div className="mx-auto max-w-md text-center">
          <div className="text-8xl font-bold text-primary/20">404</div>
          <h1 className="mt-4 text-2xl font-bold text-foreground">
            페이지를 찾을 수 없습니다
          </h1>
          <p className="mt-2 text-muted-foreground">
            요청하신 페이지가 존재하지 않거나 이동되었을 수 있습니다.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
            <Button asChild>
              <Link to="/">홈으로 이동</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/notices">공지사항 보기</Link>
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
}
